import React from "react";
import { withRouter, Link } from "react-router-dom";

const NotFound = ({ history }) => {
  return (
    <div className="wrapper">
      <div className="row">
        <div className="col-sm-6 col-sm-offset-3">
          <div class="dev-page-error-block">
            <div class="code">404</div>
            <div class="title">It looks like you have been lost...</div>

            <div class="buttons">
              <div class="row">
                <div class="col-md-6">
                  <button
                    onClick={() => {
                      history.goBack();
                    }}
                    class="btn btn-primary btn-block"
                  >
                    <i class="fa fa-angle-left pull-left" /> Go back
                  </button>
                </div>
                <div class="col-md-6">
                  <Link to={"/"} class="btn btn-danger btn-block">
                    Go Home <i class="fa fa-angle-right pull-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(NotFound);



// WEBPACK FOOTER //
// ./src/_components/NotFound/index.js